import React, { Component } from 'react'
import 'react-vis/dist/style.css'
import { XYFrame, OrdinalFrame } from 'semiotic'
import * as moment from 'moment'
import { withStyles } from 'material-ui/styles'
import { Button, Grid } from 'material-ui'
import IconButton from 'material-ui/IconButton'
import ChevronLeftIcon from 'material-ui-icons/ChevronLeft'
import ChevronRightIcon from 'material-ui-icons/ChevronRight'
import { scaleTime } from 'd3-scale'

var maxPages = 0
var action = ''

const gradient = (
  <linearGradient id="paleWoodGradient" x1="0%" y1="0%" x2="0%" y2="10%">
    <stop offset="10%" stopColor="rgb(80, 227, 194)" stopOpacity="0.5" />
    <stop offset="0%" stopColor="rgba(0, 0, 0, .1)" stopOpacity="0.5" />
  </linearGradient>
)

const axis = {
  orient: 'left',
  tickFormat: d => (
    <text
      key={`tick-${d}`}
      style={{ fill: '#cecece', textAnchor: 'end', fontSize: 10 }}
      y={-2}
    >
      {d}
    </text>
  ),
  tickValues: [
    5,
    10,
    15,
    20,
    25,
    30,
    35,
    40,
    45,
    50,
    55,
    60,
    65,
    70,
    75,
    80,
    85,
    90,
    95,
    100
  ],
  baseline: false,
  tickLineGenerator: ({ xy }) => (
    <path
      key={`tickLine-${xy.value}`}
      style={{ stroke: '#F0F0F0 ' }}
      d={`M${xy.x1},${xy.y1}L${xy.x2},${xy.y1}L${xy.x2},${xy.y1}L${xy.x1},${
        xy.y1
      }Z`}
    />
  )
}

const axes = [
  {
    orient: 'left',
    tickFormat: d => (
      <text
        key={`tick-${d}`}
        style={{ fill: '#cecece', textAnchor: 'end', fontSize: 10 }}
        y={-2}
      >
        {}
      </text>
    ),
    baseline: false,
    tickValues: [
      5,
      10,
      15,
      20,
      25,
      30,
      35,
      40,
      45,
      50,
      55,
      60,
      65,
      70,
      75,
      80,
      85,
      90,
      95,
      100
    ],
    tickLineGenerator: ({ xy }) => (
      <path
        key={`tickLine-${xy.value}`}
        style={{ stroke: '#F0F0F0 ' }}
        d={`M${xy.x1},${xy.y1}L${xy.x2},${xy.y1}L${xy.x2},${xy.y1}L${xy.x1},${
          xy.y1
        }Z`}
      />
    )
  }
]

const styles = theme => ({
  tooltipContent: {
    background: 'white',
    border: 1,
    color: 'black',
    padding: 10
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200
  },
  divAlign: {
    marginLeft: -theme.spacing.unit * 6,
    width: window.innerWidth
  },
  divChartBurnDown: {
    position: 'absolute',
    marginLeft: theme.spacing.unit * 5
  }
})

@withStyles(styles)
export default class AlchemyReadingWeeklyAvg extends Component {
  constructor(props) {
    super(props)
    this.state = {
      burnStartDate: moment(new Date(this.props.goal.goalStartDate)).startOf(
        'week'
      ),
      weeksChange: 8
    }
  }

  timelineSleepSpeed = ({ data, rScale, adjustedSize, margin }) => {
    const renderedPieces = []

    const keys = Object.keys(data)

    //todo: scale
    const widthBar = 30

    keys.forEach(key => {
      //Only one piece of data per column though we'll render multiple graphical elements
      const column = data[key]
      const sleep = column.pieceData[0]

      //You can return an array of graphics or an array of objects with extra data (see the Waterfall chart demo)
      const markObject = (
        <g
          key={`piece-${key}`}
          cursor={
            moment(new Date(sleep.data.date)).isAfter(moment(), 'day')
              ? 'auto'
              : 'pointer'
          }
          onClick={
            moment(new Date(sleep.data.date)).isAfter(moment(), 'day') ||
            action === ''
              ? () => {
                  console.log('action to add')
                }
              : () => {
                  sleep.data.type === 'blank'
                    ? action(sleep.data.date, 'add')
                    : action(sleep.data.date, 'other')
                }
          }
        >
          {column.pieceData.map((piece, index) => (
            <g key={`stack-rect-${index}`}>
              {piece.scaledVerticalValue > 0 &&
                piece.data.type === 'weeklyAvg' && (
                  <rect
                    key={`rect-pred-speed-${key}`}
                    fill={'rgba(168, 169, 255,0.5)'}
                    opacity={0.5}
                    width={widthBar}
                    height={widthBar}
                    x={column.x}
                    y={piece.scaledVerticalValue}
                    rx={widthBar / 2}
                    ry={widthBar / 2}
                  />
                )}
              {piece.scaledVerticalValue + adjustedSize[0] / 15 > 0 &&
                piece.data.type === 'weeklyAvg' && (
                  <text
                    key={`rect-pred-text-speed-end-${key}`}
                    fill={'rgba(168, 169, 255,0.7)'}
                    fontSize={adjustedSize[0] / 22}
                    opacity={1}
                    x={column.x + column.width / 9 + adjustedSize[0] / 32}
                    y={piece.scaledVerticalValue + adjustedSize[0] / 15}
                  >
                    {piece.data.pagesPerHr}
                  </text>
                )}
            </g>
          ))}
        </g>
      )

      renderedPieces.push(markObject)
    })

    return renderedPieces
  }

  timelineSleep = ({ data, rScale, adjustedSize, margin }) => {
    const renderedPieces = []

    const keys = Object.keys(data)

    //todo: scale
    const widthBar = 30

    keys.forEach(key => {
      //Only one piece of data per column though we'll render multiple graphical elements
      const column = data[key]
      const sleep = column.pieceData[0]

      //You can return an array of graphics or an array of objects with extra data (see the Waterfall chart demo)
      const markObject = (
        <g
          key={`piece-${key}`}
          cursor={
            moment(new Date(sleep.data.date)).isAfter(moment(), 'day')
              ? 'auto'
              : 'pointer'
          }
          onClick={
            moment(new Date(sleep.data.date)).isAfter(moment(), 'day') ||
            action === ''
              ? () => {
                  console.log('action to add')
                }
              : () => {
                  sleep.data.type === 'blank'
                    ? action(sleep.data.date, 'add')
                    : action(sleep.data.date, 'other')
                }
          }
        >
          {column.pieceData.map((piece, index) => (
            <g key={`stack-rect-${index}`}>
              {piece.scaledValue > 0 &&
                piece.data.type === 'goalpattern' && (
                  <rect
                    key={`rect-goal-${key}`}
                    fill={'rgba(0, 0, 0, 0.06)'}
                    opacity={0.5}
                    width={widthBar}
                    height={piece.scaledValue}
                    x={column.x}
                    y={piece.scaledVerticalValue}
                    rx={2}
                    ry={3}
                  />
                )}
              {piece.scaledVerticalValue > 0 &&
                piece.data.type === 'sessionRecord' && (
                  <rect
                    key={`rect-readingSession-${key}`}
                    fill={'lightgrey'}
                    opacity={0.3}
                    width={3}
                    height={3}
                    x={column.x}
                    y={piece.scaledVerticalValue}
                    rx={2}
                    ry={2}
                  />
                )}
              {piece.scaledValue > 0 &&
                piece.data.type === 'weeklyAvg' && (
                  <rect
                    key={`rect-pred-${key}`}
                    fill={'lightgreen'}
                    opacity={0.5}
                    width={widthBar}
                    height={piece.scaledValue}
                    x={column.x}
                    y={piece.scaledVerticalValue}
                    rx={3}
                    ry={3}
                  />
                )}
              {piece.scaledVerticalValue + adjustedSize[0] / 18 > 0 &&
                piece.data.type === 'weeklyAvg' && (
                  <text
                    key={`rect-pred-text-end-${key}`}
                    fill={'white'}
                    fontSize={adjustedSize[0] / 18}
                    opacity={1}
                    x={column.x + column.width / 9 + adjustedSize[0] / 32}
                    y={piece.scaledVerticalValue + adjustedSize[0] / 18}
                  >
                    {piece.data.pages}
                  </text>
                )}
            </g>
          ))}
        </g>
      )

      renderedPieces.push(markObject)
    })

    return renderedPieces
  }

  addBlankDate = (s, w, data) => {
    var iDateStart = moment(new Date(this.state.burnStartDate)).startOf('week')
    var iDateEnd = moment(new Date(this.state.burnStartDate))
      .add(w, 'weeks')
      .endOf('week')
    var daysWeek = iDateEnd.diff(iDateStart, 'days') + 1

    for (var i = 0; i < daysWeek; i++) {
      var blankDate = iDateStart
      var isSame = false

      for (var j in data) {
        if (
          moment(new Date(data[j].date)).format('l') === blankDate.format('l')
        ) {
          isSame = true
        }
      }
      if (!isSame) {
        data.splice(i, 0, {
          date: blankDate.format('l'),
          mins: 0,
          pages: 0,
          type: 'blank'
        })
        isSame = false
      }

      iDateStart = moment(blankDate).add(1, 'd')
    }

    return data
  }

  calcWeeklyAvg = (date, data) => {
    var avg = ''

    var minsAvg = 0
    var pagesAvg = 0
    var pagesPerHr = 0

    var dates = data.filter(
      s =>
        moment(new Date(s.date))
          .startOf('week')
          .format('l') ===
        moment(new Date(date))
          .startOf('week')
          .format('l')
    )

    if (dates && dates.length > 0) {
      dates.forEach(d => {
        pagesPerHr += d.pages * 60 / d.mins
        minsAvg += d.mins
        pagesAvg += d.pages
      })

      minsAvg = minsAvg / dates.length
      pagesAvg = pagesAvg / dates.length
      pagesPerHr = pagesPerHr / dates.length

      avg = {
        date: date,
        mins: minsAvg.toFixed(0),
        pages: pagesAvg.toFixed(0),
        pagesPerHr: pagesPerHr.toFixed(0),
        type: 'weeklyAvg'
      }
    }
    return avg
  }

  prevPeriod = () => {
    const prevPeriod = moment(new Date(this.state.burnStartDate)).subtract(
      this.state.weeksChange + 1,
      'weeks'
    )
    this.setState({
      burnStartDate: prevPeriod.startOf('week')
    })
  }

  nextPeriod = () => {
    const nextPeriod = moment(new Date(this.state.burnStartDate)).add(
      this.state.weeksChange + 1,
      'weeks'
    )
    this.setState({
      burnStartDate: nextPeriod.startOf('week')
    })
  }

  setToday = () => {
    this.setState({
      burnStartDate: moment(new Date(this.props.goal.goalStartDate)).startOf(
        'week'
      )
    })
  }

  render() {
    if (this.props.data && this.props.data.loading) {
      return <div>Loading</div>
    }

    if (this.props.data && this.props.data.error) {
      return <div>Error</div>
    }

    const { classes } = this.props
    const tmp = this.props.data

    let burnEndDate = moment(new Date(this.state.burnStartDate))
      .endOf('week')
      .add(this.state.weeksChange, 'weeks')

    const dataSleepWeekly = tmp.filter(e =>
      moment(new Date(e[0])).isBetween(
        this.state.burnStartDate,
        burnEndDate,
        null,
        []
      )
    )

    var dataChartSleepWeekly = []
    const sleepDays = dataSleepWeekly.length

    // session data
    for (var i = 0; i < sleepDays; i++) {
      dataChartSleepWeekly.splice(i, 0, {
        date: moment(new Date(dataSleepWeekly[i][0])).format('l'),
        mins: dataSleepWeekly[i][2],
        pages: dataSleepWeekly[i][3],
        type: 'sessionRecord'
      })
    }

    //add goalpattern and average weekly data
    for (i = 0; i <= this.state.weeksChange; i++) {
      var predWeeklyDate = moment(new Date(this.state.burnStartDate)).day(
        'monday'
      )

      var predData = {
        date: predWeeklyDate
          .add(i, 'week')
          .startOf('week')
          .format('l'),
        mins: this.props.goal.durationMinGoalLow,
        pages: this.props.goal.pagesGoalHigh,
        type: 'goalpattern'
      }
      dataChartSleepWeekly.splice(0, 0, predData)

      //add average weekly data
      var avgData = this.calcWeeklyAvg(
        predData.date,
        dataChartSleepWeekly.filter(d => d.type === 'sessionRecord')
      )

      if (avgData) {
        dataChartSleepWeekly.splice(0, 0, avgData)
      }
    }

    //add blank days
    dataChartSleepWeekly = this.addBlankDate(
      this.props.goal.goalStartDate,
      this.state.weeksChange,
      dataChartSleepWeekly
    )

    //sort to ensure area chart to display correctly
    dataChartSleepWeekly.sort(function(a, b) {
      return new Date(a.date) - new Date(b.date)
    })

    //find max
    var pagesForMax = []
    var minsForMax = []
    dataChartSleepWeekly.forEach(e => {
      var p = 0
      if (e.type === 'weeklyAvg') {
        if (e.pages >= e.pagesPerHr) {
          p = e.pages
        } else {
          p = e.pagesPerHr
        }
      } else {
        p = e.pages
      }
      e.mins > 0 && minsForMax.push(e.mins)
      e.pages > 0 && pagesForMax.push(p)
    })

    maxPages = Math.max.apply(null, pagesForMax)

    return (
      <div className={classes.divAlign}>
        <div
          id="switch-weeks"
          style={{
            width: '70%',
            marginLeft: '15%',
            marginRight: '15%'
          }}
        >
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="baseline"
            spacing={0}
          >
            <Grid item xs={2} />
            <Grid item xs={2}>
              <IconButton
                onClick={() => this.prevPeriod()}
                className="btn btn-default btn-style"
              >
                <ChevronLeftIcon style={{ fontSize: 30 }} />
              </IconButton>
            </Grid>
            <Grid item xs={4}>
              <span style={{ fontSize: 14 }}>
                {this.state.burnStartDate.format('M/D')} -{' '}
                {burnEndDate.format('M/D')}
              </span>
            </Grid>
            <Grid item xs={2}>
              <IconButton
                onClick={() => this.nextPeriod()}
                className="btn btn-default btn-style"
              >
                <ChevronRightIcon style={{ fontSize: 30 }} />
              </IconButton>
            </Grid>
            <Grid item xs={2}>
              {moment().isBetween(
                this.state.burnStartDate,
                burnEndDate,
                null,
                '[]'
              ) ? (
                ''
              ) : (
                <Button
                  onClick={() => this.setToday()}
                  className={classes.icon}
                  size="small"
                >
                  <span style={{ fontSize: 10 }}>Today</span>
                </Button>
              )}
            </Grid>
          </Grid>
        </div>
        <div
          id="daily_sleep_chart_view"
          style={{
            position: 'relative',
            textAlign: 'center',
            width: this.props.width,
            height: this.props.height
          }}
        >
          <div className={classes.divChartBurnDown}>
            <XYFrame
              size={[this.props.width / 1.1 + 3, this.props.height]}
              margin={{
                left: this.props.width / 10 + 8,
                top: this.props.height / 60,
                right: this.props.width / 10,
                bottom: this.props.height / 9.6
              }}
              xScaleType={scaleTime()}
              xAccessor={d => new Date(d.date)}
              yAccessor={d => d.type === 'sessionRecord' && d.pages}
              areas={[{ label: 'pages', coordinates: dataChartSleepWeekly }]}
              areaStyle={() => ({ fill: 'url(#paleWoodGradient)' })}
              additionalDefs={gradient}
              defined={d => d.pages > 1}
              axes={axes}
              yExtent={[0, maxPages]}
            />
          </div>
          <div className={classes.divChartBurnDown}>
            <OrdinalFrame
              size={[this.props.width / 1.1, this.props.height]}
              data={dataChartSleepWeekly}
              rAccessor={d => d.pages}
              oAccessor={d => moment(new Date(d.date)).format('YYYY/MM/DD')}
              sortO={(a, b) => a > b}
              rExtent={[0, maxPages]}
              type={{
                type: this.timelineSleep,
                rotate: 180
              }}
              projection="vertical"
              oPadding={this.props.width / 35}
              margin={{
                left: this.props.width / 10,
                top: this.props.height / 60,
                right: this.props.width / 10,
                bottom: this.props.height / 9.6
              }}
              hoverAnnotation={false}
            />
          </div>
          <div className={classes.divChartBurnDown}>
            <OrdinalFrame
              size={[this.props.width / 1.1, this.props.height]}
              data={dataChartSleepWeekly}
              rAccessor={d => d.type === 'weeklyAvg' && d.pagesPerHr}
              oAccessor={d => moment(new Date(d.date)).format('YYYY/MM/DD')}
              sortO={(a, b) => a > b}
              rExtent={[0, maxPages]}
              type={{
                type: this.timelineSleepSpeed,
                rotate: 180
              }}
              projection="vertical"
              oPadding={this.props.width / 35}
              axis={axis}
              margin={{
                left: this.props.width / 10,
                top: this.props.height / 60,
                right: this.props.width / 10,
                bottom: this.props.height / 9.6
              }}
              oLabel={d => (
                <text
                  key={`label-${d}`}
                  fill="#cecece"
                  textAnchor="middle"
                  fontSize={10}
                  x={5}
                >
                  {moment(new Date(d)).day() === 0
                    ? moment(new Date(d)).format('M/D')
                    : ''}
                </text>
              )}
              hoverAnnotation={false}
            />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ChartTypes/AlchemyReadingWeeklyAvg.js